import React, { Component } from "react";
import Slider from "react-slick";

//IMPORT IMAGES
import blueLotusImage from '../../frontend/assets/img/Jainism/blue lotus.png';
import prayingBoyImage from '../../frontend/assets/img/Jainism/prayingboyHQ.png';
import circleKidsImage from '../../frontend/assets/img/Jainism/circlekids.svg';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }

    render() {
        function SampleNextArrow(props) {
            const { onClick } = props;
            return (
                <button onClick={onClick} data-slick-prev="#sliderOne" className="simple-arrow arrow-left"><i className="far fa-chevron-left"></i></button>

            );
        }

        function SamplePrevArrow(props) {
            const { onClick } = props;
            return (
                <button onClick={onClick} data-slick-next="#sliderOne" className="simple-arrow arrow-right"><i className="far fa-chevron-right"></i></button>
            );
        }
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <React.Fragment>
                <section className="about-section bg-smoke space">
                    <div className="container">
                        <div className="row flex-column-reverse flex-lg-row align-items-center gy-30">
                            <div className="col-lg-5 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="text-center text-lg-start">
                                    <span className="sub-title">More About Us</span>
                                    <h2 className="sec-title big-title">“My Jainism” - Ek Sanskar Mandir</h2>
                                    <p className="fs-md mb-30" style={{ fontSize: 30 }}>is a non-profit organization who is working to imbibe Jainism values along with Basic moral values into the children in the age group of 5 to 15 years.</p>
                                    <a href={process.env.PUBLIC_URL + "/about-us"} className="vs-btn wave-btn style-1">About Us</a>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="shape-slider-area">
                                    <div className="shape-slider vs-carousel" id="sliderOne" data-slide-show="1" data-md-slide-show="1">
                                        <Slider {...settings} >
                                            <div className="slide-item">
                                                <img className="line-1 slideinup vs-animated" data-ani="slideinup" data-ani-delay=".2s" src={require('../../frontend/assets/img/Jainism/shape 2.png')} alt="shape" />
                                                <img className="line-2 slideinup vs-animated" data-ani="slideinup" data-ani-delay=".5s" src={require('../../frontend/assets/img/Jainism/shape 1.png')} alt="shape" />
                                                <img src={require('../../frontend/assets/img/shape/shape-slide-12.png')} alt="shape" />
                                            </div>
                                            <div className="slide-item">
                                                <img className="line-1 slideinup vs-animated" data-ani="slideinup" data-ani-delay=".2s" src={require('../../frontend/assets/img/Jainism/shape 2.png')} alt="shape" />
                                                <img className="line-2 slideinup vs-animated" data-ani="slideinup" data-ani-delay=".5s" src={require('../../frontend/assets/img/Jainism/shape 1.png')} alt="shape" />
                                                <img src={require('../../frontend/assets/img/shape/shape-slide-2.png')} alt="shape" />
                                            </div>
                                            <div className="slide-item">
                                                <img className="line-1 slideinup vs-animated" data-ani="slideinup" data-ani-delay=".2s" src={require('../../frontend/assets/img/Jainism/shape 2.png')} alt="shape" />
                                                <img className="line-2 slideinup vs-animated" data-ani="slideinup" data-ani-delay=".5s" src={require('../../frontend/assets/img/Jainism/shape 1.png')} alt="shape" />
                                                <img src={require('../../frontend/assets/img/shape/shape-slide-3.png')} alt="shape" />
                                            </div>
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape-mockup shapePulse d-lg-block blue-lotus" data-bottom="22%" data-right="5%" style={{ width: "4%" }}><img src={blueLotusImage} alt="shape" /></div>
                    <div className="shape-mockup shapePulse d-hd-block tablet-vectors mobile-vectors laptop-vectors" data-top="17%" data-left="6%" style={{ width: "4%" }}><img src={prayingBoyImage} alt="shape" /></div>
                    <div className="shape-mockup rotate d-none d-sm-block z-index-2 circlekids-vector" data-bottom="-15%" data-left="6%"><img src={circleKidsImage} alt="shape" /></div>

                </section>
            </React.Fragment >
        );
    }
}

export default About;
